import React, { Component } from 'react';

import {
  Col,
  Container,
  Input,
  Row,
  Table,
  FormGroup,
  Label,
  Button
} from 'reactstrap';

import moment from 'moment';

const MinDate = moment('2017-07-01');
const dateFormat = 'YYYY-MM-DD';

const exceptions = {
    july2017: '2019-03-31',
    august2017: '2019-03-31',
    september2017: '2019-03-31',
    october2017: '2019-03-31',
    november2017: '2019-03-31',
    december2017: '2019-03-31',
    january2018: '2019-03-31',
    february2018: '2019-03-31',
    march2018: '2019-03-31',
    april2018: '2019-03-31',
    may2018: '2019-03-31',
    june2018: '2019-03-31',
    july2018: '2019-03-31',
    august2018: '2019-03-31',
    september2018: '2019-03-31',
    march2019: '2019-04-23',
    july2019: '2019-08-22',
    november2019: '2019-12-26',
    february2020: '2020-06-30',
    march2020: '2020-07-03',
    april2020: '2020-07-06'
};

const DEFAULT_LAST_DATE = 20;
const NIL_FEE = 20;
const TAX_FEE = 50;
const MAX_FEE = 10000;


function ListItem(props) {
  return (
    <tr>
      <td>{props.month.name}</td>
      <td style={{ textAlign: 'right' }}>
        <div>{props.month.days}</div>
        <div style={{fontSize: '.7em'}}>* Since {props.month.dueDate.format('DD/MM/YYYY')}</div>
      </td>
      <td>
        <input
          type="number"
          step="0.01"
          value={props.month.tax}
          onChange={(e) => props.onChange(props.index, e.target.value)}
          placeholder={props.month.tax}
          >
        </input>
      </td>
      <td style={{ textAlign: 'right' }}>{props.month.lateFee}</td>
      <td style={{ textAlign: 'right' }}>
        {props.month.interest}
      </td>
    </tr>
  );
}

function RenderRows(props) {
  return(
    <tbody>
      {props.months.map( (m, idx) => <ListItem key={m.name} month={m} index={idx} onChange={props.onChange} />)}
    </tbody>
  );
};


class LateFeeCalculator extends Component {
  constructor (props) {
    super(props);

    this.state = {
      minDate: MinDate,
      startDate: MinDate,
      startMonth: MinDate,
      endDate: moment(),
      financialYears: {},
      lateMonths: [],
      totalLateFee: 0,
      totalInterest: 0,
      carryOverDays: 0,
      carryOverNil: true
    };

    this.handleChangeEnd = this.handleChangeEnd.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.getMonths = this.getMonths.bind(this);
    this.calculateAllMonths = this.calculateAllMonths.bind(this);
    this.reCalculateMonth = this.reCalculateMonth.bind(this);
    this.handleCarryOverNilReturnChange = this.handleCarryOverNilReturnChange.bind(this);
    this.handleCarryOverDaysChange = this.handleCarryOverDaysChange.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentWillMount() {
    this.prepareFinancialYears();
    this.getMonths();
  }

  getMonths() {
    const fees = [];
    const oct2020 = moment('2020-10-01');
    const start = this.state.startMonth.clone(); // Always 1 of the month
    // Make it 1st of the month for easy comparision with start.
    const end = this.state.endDate.clone()
          .startOf('month');

    while (end > start) {
      const str = start.format('MMMMYYYY').toLowerCase();
      let dueDate = start.clone();

      // For current month, filing is next
      // done in the next month.
      dueDate.add(1, 'month');

      const data = {
        name: start.format('MMMM YYYY'),
        nilReturn: true,
        lateFee: 0,
        exempted: false,
        days: 0,
        tax: 0,
        interest: 0
      };

      if (exceptions[str]) {
        // Due date is next day.
        dueDate = moment(exceptions[str]).add(1, 'days');
      }
      else {
	if (dueDate > oct2020) {
	  dueDate.add(DEFAULT_LAST_DATE + 4, 'days');
	} else {
	  dueDate.add(DEFAULT_LAST_DATE, 'days');
	}

      }

      // Fee is inclusive of payment days so we add +1 day.
      data.days = this.state.endDate.diff(dueDate, 'days') + 1;
      data.dueDate = dueDate;

      // Some months may have extended last date.
      // This will result in -ve days.
      // We exclude those days.
      // e.g for April 2018, it's 22nd. Payment on 21 May will result on -1 day.
      if (data.days > -1) {
        fees.push(data);
      }
      start.add(1, 'month');
    }

    this.setState(() => {
      return {
        lateMonths: fees
      };
    }, this.calculateAllMonths);
  }

  calculateLateFee(month) {
    const rate = month.nilReturn ? NIL_FEE : TAX_FEE;
    if (month.exempted) {
      month.lateFee = 0;
      return month;
    }
    month.lateFee = month.days * rate;
    if (month.lateFee > MAX_FEE) {
      month.lateFee = MAX_FEE;
    }
    return month;
  }

  calculateInterest(month) {
    if (month.nilReturn) {
      month.interest = 0;
      return month;
    }
    month.interest = Number((month.tax * (month.days / 365) * 0.18).toFixed(2));
    return month;
  }

  calculateAllMonths() {
    let totalLateFee = 0;
    let totalInterest = Number(0);
    const months = this.state.lateMonths;
    months.forEach((month, idx) => {
      month = this.calculateLateFee(month);
      month = this.calculateInterest(month);
      totalLateFee += month.lateFee;
      totalInterest += month.interest;
      months[idx] = month;
    });

    totalInterest = Number(totalInterest.toFixed(2));

    const carryOverRate = this.state.carryOverNil ? NIL_FEE : TAX_FEE;
    totalLateFee += this.state.carryOverDays * carryOverRate;

    this.setState({
      lateMonths: months,
      totalLateFee,
      totalInterest
    });
  }

  reCalculateMonth(idx, tax) {
    const data = this.state.lateMonths;
    let month = data[idx];
    let totalLateFee = this.state.totalLateFee;
    let totalInterest = this.state.totalInterest;
    let t = Number(tax);
    totalLateFee -= month.lateFee;
    totalInterest -= month.interest;
    month.tax = t;
    month.nilReturn = month.tax <= 0;
    month = this.calculateLateFee(month);
    month = this.calculateInterest(month);
    data[idx] = month;
    totalLateFee += month.lateFee;
    totalInterest += month.interest;
    this.setState(() => {
      return {
        lateMonths: data,
        totalLateFee,
        totalInterest
      };
    });
  }

  prepareFinancialYears() {
    const start = this.state.startDate.clone();
    const end = this.state.endDate.clone();
    let fiscal = `${start.year()} - ${start.year() + 1}`;
    const tmp = { [fiscal]: [] };
    this.setState({
      selectedFinancialYear: fiscal
    });

    while (end > start || start.format('M') === end.format('M')) {
      const month = {
        name: start.format('MMMM'),
        dt: start.format(dateFormat)
      };

      // if the startting month is not April, push it to existing
      // fiscal year. Else, it's the start of a new Fiscal year.
      if (start.month() !== 3) {
        tmp[fiscal].push(month);
      } else {
        fiscal = `${start.year()} - ${start.year() + 1}`;
        tmp[fiscal] = [];
        tmp[fiscal].push(month);
      }
      start.add(1, 'month');
    }
    this.setState({
      financialYears: tmp
    });
  }

  handleYearChange(e) {
    const val = e.target.value;
    this.setState({
      selectedFinancialYear: val,
      startMonth: moment(this.state.financialYears[val][0].dt)
    }, this.getMonths);
  }

  handleMonthChange(e) {
    this.setState({
      startMonth: moment(e.target.value)
    }, this.getMonths);
  }

  handleChangeEnd(e) {
    this.setState({
      endDate: moment(e.target.value)
    }, this.getMonths);
  }

  handleCarryOverNilReturnChange(flag) {
    this.setState({
      carryOverNil: flag
    }, this.calculateAllMonths);
  }

  handleCarryOverDaysChange(e) {
    this.setState({
      carryOverDays: e.target.value
    }, this.calculateAllMonths);
  }

  reset() {
    this.getMonths();
  }

  render() {
    return (
      <div className="flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col xs="12" lg="8">
              <div className="card">
                <div className="card-body">
                  <FormGroup row>
                    <Col md="6">
                      <Label>Starting Financial Year</Label>
                      <Input
                        type="select"
                        onChange={this.handleYearChange}
                        >
                        {Object.keys(this.state.financialYears).map((name) => {
                          return <option value={name}>{name}</option>;
                        })}
                      </Input>
                    </Col>
                    <Col md="6">
                      <Label>Starting Month</Label>
                      <Input
                        type="select"
                        onChange={this.handleMonthChange}
                        >
                        {this.state.financialYears[this.state.selectedFinancialYear].map((month) => {
                          return <option value={month.dt}>{month.name}</option>;
                        })}
                      </Input>
                    </Col>
                  </FormGroup>

                  <FormGroup row>
                    <Col md="6">
                      <Label htmlFor="date-input">Payment Date</Label>
                      <Input
                        type="date"
                        id="date-input"
                        name="date-input"
                        placeholder="date"
                        value={this.state.endDate.format('YYYY-MM-DD')}
                        onChange={this.handleChangeEnd}  />
                    </Col>
                  </FormGroup>

                  <FormGroup>
                    <Table striped bordered condensed hover responsive className="mt-3">
		      <thead>
			<tr>
			  <th colSpan="5" align="center" className="text-center">Michma GST-3B Latefee Calculator</th>
			</tr>
		      </thead>
                      <thead>
                        <tr>
                          <th>Month</th>
                          <th>Number of Days</th>
                          <th>Liability</th>
                          <th>Late Fee</th>
                          <th>Interest</th>
                        </tr>
                      </thead>
                      <RenderRows months={this.state.lateMonths} onChange={this.reCalculateMonth} />
                      <tr>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'right' }}>CGST</td>
                        <td style={{ textAlign: 'right' }}>{(this.state.totalLateFee / 2).toFixed(2)}</td>
                        <td style={{ textAlign: 'right' }}>{(this.state.totalInterest / 2).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'right' }}>SGST</td>
                        <td style={{ textAlign: 'right' }}>{(this.state.totalLateFee / 2).toFixed(2)}</td>
                        <td style={{ textAlign: 'right' }}>{(this.state.totalInterest / 2).toFixed(2)}</td>
                      </tr>

                      <tr>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(this.state.totalLateFee).toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(this.state.totalInterest).toFixed(2)}</td>
                      </tr>
                    </Table>
                  </FormGroup>
                  <div>
                    <p>
		      * Filing due date is based on the state of Meghalaya and turnover of upto 5 Crore. <br />
                      * Calculation is based on a rate of {NIL_FEE} per day for Nil Returns and {TAX_FEE} per day for Non Nil Returns. <br />
                      * Interest is calulated on a rate of 18% per annum. <br />
                      ** This calculation is for reference only and should not be taken as final. However we try our best to maintain the accuracy of the calculation according to the notifications issued by the government of India. Last updated on <strong>January 04, 2020</strong>
		    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}


export default LateFeeCalculator;



// WEBPACK FOOTER //
// ./src/lateFeeCalculator.js